/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ThemesActions from "../../actions/themesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const editThemeLogic = createLogic({
	type: ActionTypes.EDIT_THEME,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());
		const { id, theme, appKey } = action;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 10000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/themes/${id}`, theme)
					.then(() => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(ThemesActions.editThemeSuccess(appKey));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(ThemesActions.editThemeFailure(error));
						done();
					});
			});
	},
});

export default [editThemeLogic];
